var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page',{attrs:{"name":"Endgame Settings","plural":"Endgame Settings","use":"_id","display":_vm.display,"page-prefix":"/blade/outros","fetch":_vm.getOutros,"remove":_vm.deleteOutro}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63bb72d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/OutrosList.vue
// module id = null
// module chunks = 